// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"49ccb12c","223":"2e772c99","321":"b006142c","433":"a679f6bf","573":"91ef26b8","830":"f2f777e1"}[chunkId] + ".chunk.js";
};